import Vue from 'vue'
import Router from 'vue-router'
import Login from '../components/Login'
import Home from '../components/Home/Home'
import JobWanted from '../components/JobWanted/JobWanted'
import Recruit from '../components/Recruit/Recruit'
import SocialSecurity from '../components/SocialSecurity/SocialSecurity'
import PersonalCenter from '../components/PersonalCenter/PersonalCenter'
import Resume from '../components/Resume/Resume'
import store from 'good-storage'
import { MessageBox } from 'element-ui'
import MyFollow from '../components/MyFollow/MyFollow'
import MyApply from '../components/MyApply/MyApply'
import JobDetail from '../components/JobDetailPage/JobDetail'
import RegisterUser from '../components/RegisterUser'
import NewsManage from '../components/NewsManage/NewsManage'
import RecruiterReview from '../components/RecruiterReview/RecruiterReview'
import ReceiveOrder from '../components/ReceiveOrder/ReceiveOrder'
import TalentsPool from '../components/TalentsPool/TalentsPool'
import HomeManage from '../components/HomeManage/HomeManage'

const originalPush = Router.prototype.push  //todo
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)
let redirectRoute = (!store.get('user')) ? '/home' : (store.get('user') && store.get('user').roleName !== 'admin') ? '/home' : '/home-manage'
const router = new Router({
  routes: [
    {
      path: '/',
      redirect: redirectRoute // 默认url重定向页面
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/register',
      name: 'RegisterUser',
      component: RegisterUser
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/job-wanted',
      name: 'JobWanted',
      component: JobWanted
    },
    {
      path: '/recruit',
      name: 'Recruit',
      component: Recruit
    },
    {
      path: '/social-security',
      name: 'SocialSecurity',
      component: SocialSecurity
    },
    {
      path: '/personal-center',
      name: 'PersonalCenter',
      component: PersonalCenter
    },
    {
      path: '/resume',
      name: 'Resume',
      component: Resume
    },
    {
      path: '/my-follow',
      name: 'MyFollow',
      component: MyFollow
    },
    {
      path: '/my-apply',
      name: 'MyApply',
      component: MyApply
    },
    {
      path: '/job-detail',
      name: 'JobDetail',
      component: JobDetail
    },
    {
      path: '/news-manage',
      name: 'NewsManage',
      component: NewsManage
    },
    {
      path: '/recruiter-review',
      name: 'RecruiterReview',
      component: RecruiterReview
    },
    {
      path: '/receive-order',
      name: 'ReceiveOrder',
      component: ReceiveOrder
    },
    {
      path: '/talents-pool',
      name: 'TalentsPool',
      component: TalentsPool
    },
    {
      path: '/home-manage',
      name: 'HomeManage',
      component: HomeManage
    }
  ]
})

// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
// todo: 目前不要登录路由，登录页面是弹出的，此处业务待定
let adminMenu = ['/home-manage', '/news-manage', '/recruiter-review', '/receive-order', '/personal-center', '/talents-pool']
router.beforeEach((to, from, next) => {
  if (to.path === '/login' || to.path === 'register') {
    next()
  } else {
    if (store.get('user') && store.get('user')['roleName'] === 'admin' && adminMenu.indexOf(to.path) < 0) {
      next('/home-manage')
    } else if (to.path === '/recruit' && store.get('user') && store.get('user')['roleName'] === 'jobseeker') {
      MessageBox.alert('请退出登录后使用招聘者角色的账号登录用于发布职位信息！', '提示', {type: 'warning'})
    } else if (to.path === '/resume' && store.get('user')['roleName'] === 'enterprise') {
      next('/home')
    } else {
      next()
    }
    // }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js